import { redirectToLogin } from '@/utils/redirect';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink, from } from '@apollo/client';

import { onError } from '@apollo/client/link/error';

const errorLink = onError((error) => {
  const { graphQLErrors, networkError } = error;
  console.error({ error });

  if (graphQLErrors) {
    graphQLErrors.map(({ message }) => {
      if (message === 'UNAUTHENTICATED' || message === 'Forbidden access') {
        redirectToLogin();
      }
    });
  }

  if (
    (networkError && 'response' in networkError && networkError.response.statusText.includes('Unauthorized')) ||
    (networkError && 'statusCode' in networkError && networkError.statusCode === 401)
  ) {
    redirectToLogin();
  }
});

const httpLink = createHttpLink({
  uri: `${import.meta.env.VITE_API_URL}/graphql`,
});

const authLink = new ApolloLink((operation, forward) => {
  const ctx = operation.getContext() as { headers?: Record<string, string>; skipAuth?: boolean };
  const token = JSON.parse(localStorage.getItem('authentication') || '{}').accessToken;
  if (!ctx.skipAuth) {
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      },
    });
  }
  return forward(operation);
});

export const client = new ApolloClient({
  link: from([authLink, httpLink, errorLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
    },
  },
});

export const initializeApollo = () => {
  return client;
};

export const initializeApolloWithoutToken = () => {
  return new ApolloClient({
    link: from([httpLink, errorLink]),
    cache: new InMemoryCache(),
  });
};
